<template>
    <div>
        <v-layout row align-center class="mr-2 sms-date-filter-row">
            <v-spacer></v-spacer>
            <v-menu
                v-model="datePickerMenu"
                :close-on-content-click="false"
                offset-y
                :nudge-bottom="4"
                min-width="290"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        :value="fromDate"
                        label="Show Messages From"
                        prepend-icon="mdi-calendar"
                        readonly
                        box
                        dense
                        v-on="on"
                        class="mx-2 sms-date-field"
                        hide-details
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="fromDate"
                    @change="fromDateChanged(fromDate)"
                ></v-date-picker>
            </v-menu>
        </v-layout>
        <v-card
            class="account-messages-scroll-down elevation-0"
            style="background-color: #f1ffdc"
            ref="accountMessages"
        >
            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <v-timeline class="petition-timeline mx-3" style="" v-if="!loading">
                <div v-for="message in messages">
                    <v-timeline-item
                        v-if="message.direction == 'INC'"
                        color="blue lighten-2"
                        right
                    >
                        <v-card>
                            <v-card-title class="py-1 blue lighten-2">
                                <h2
                                    class="body-1 my-0 white--text font-weight-light"
                                >
                                    <div>
                                        <v-icon dark size="15" class="mr-2">
                                            mdi-cellphone
                                        </v-icon>
                                        {{ message.dateTime | time }}
                                    </div>
                                    <div>
                                        FROM:
                                        {{ formatPhoneNumber(message.from) }}
                                        TO: {{ formatPhoneNumber(message.to) }}
                                    </div>
                                </h2>
                            </v-card-title>
                            <v-container class="pa-3">
                                <v-layout
                                    class="px-2 pt-1"
                                    v-if="message.attachmentUrls"
                                >
                                    <v-flex xs10 class="py-0 body-2">
                                        <div
                                            v-for="image in message.attachmentUrls.split(
                                                ';',
                                            )"
                                        >
                                            <v-img :src="image"></v-img>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="px-2 pt-1">
                                    <v-flex
                                        xs10
                                        class="py-0 body-2 account-message-text"
                                    >
                                        {{ message.text }}
                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    class="mark-as-completed-tooltip"
                                    row
                                    justify-end
                                    style="font-size: 11px"
                                >
                                    <v-spacer></v-spacer>
                                    <div
                                        class="mr-2"
                                        style="cursor: pointer; color: rgb(92, 184, 96); font-size: 11px;"
                                        @click="reply(message)"
                                    >
                                        REPLY
                                    </div>
                                    <!-- <div
                                        v-if="message.status != 'PENDING'"
                                        class="text-xs-right px-2 account-message-status account-message-status-completed"
                                    >
                                        READ
                                    </div> -->
                                    <v-tooltip
                                        style="opacity: 1 !important"
                                        min-width="275"
                                        v-if="message.status != 'PENDING'"
                                        :value="
                                            messageTooltip.includes(message.id)
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div
                                                v-on:click="
                                                    openMarkCompletedTooltip(
                                                        message,
                                                    )
                                                "
                                                style="cursor: pointer"
                                                class="text-xs-right px-2 account-message-status account-message-status-completed"
                                            >
                                                READ
                                            </div>
                                        </template>
                                        <div
                                            class="pt-2"
                                            @mouseleave="closeTooltip(message)"
                                        >
                                            <span class="tooltip-title mt-2"
                                                >MARK AS UNREAD?</span
                                            >
                                            <v-layout
                                                row
                                                justify-center
                                                class="mt-4 mb-2"
                                            >
                                                <v-btn
                                                    small
                                                    color="warning"
                                                    :disabled="processing"
                                                    @click="
                                                        markAsUnread(message)
                                                    "
                                                    class="mr-3 mb-0 mark-message-button"
                                                    >Confirm</v-btn
                                                >
                                            </v-layout>
                                        </div>
                                    </v-tooltip>
                                    <v-tooltip
                                        style="opacity: 1 !important"
                                        min-width="275"
                                        v-if="message.status == 'PENDING'"
                                        :value="
                                            messageTooltip.includes(message.id)
                                        "
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <!-- <v-btn color="primary" dark v-on="on">Left</v-btn> -->
                                            <div
                                                v-on:click="
                                                    openMarkCompletedTooltip(
                                                        message,
                                                    )
                                                "
                                                class="text-xs-right px-2 account-message-status account-message-status-pending"
                                            >
                                                {{ message.status }}
                                            </div>
                                        </template>
                                        <div
                                            class="pt-2"
                                            @mouseleave="closeTooltip(message)"
                                        >
                                            <span class="tooltip-title mt-2"
                                                >MARK AS READ?</span
                                            >
                                            <v-layout
                                                row
                                                justify-center
                                                class="mt-4 mb-2"
                                            >
                                                <v-btn
                                                    small
                                                    color="#aeb8bf"
                                                    :disabled="processing"
                                                    @click="
                                                        markAsCompleted(message)
                                                    "
                                                    class="mr-3 mb-0 mark-message-button"
                                                    >Mark This</v-btn
                                                >
                                                <v-btn
                                                    small
                                                    color="#aeb8bf"
                                                    :disabled="processing"
                                                    @click="
                                                        markAsCompleted(
                                                            message,
                                                            true,
                                                        )
                                                    "
                                                    class="mb-0 mark-message-button"
                                                    >Mark All</v-btn
                                                >
                                            </v-layout>
                                        </div>
                                    </v-tooltip>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-timeline-item>
                    <v-timeline-item
                        v-if="message.direction == 'OUT'"
                        color="rgb(92, 184, 96)"
                        left
                    >
                        <v-card>
                            <v-card-title
                                style="background-color: rgb(92, 184, 96)"
                                class=" py-1"
                            >
                                <h2
                                    class="body-1 my-0 white--text font-weight-light"
                                >
                                    <div>
                                        <v-icon dark size="15" class="mr-2">
                                            mdi-laptop-windows
                                        </v-icon>
                                        {{ message.dateTime | time }}
                                        {{ " - " + message.username }}
                                    </div>
                                    <div>
                                        FROM:
                                        {{ formatPhoneNumber(message.from) }}
                                        TO: {{ formatPhoneNumber(message.to) }}
                                    </div>
                                </h2>
                            </v-card-title>
                            <v-container class="pa-3">
                                <v-layout class="px-2 pt-1">
                                    <v-flex
                                        xs10
                                        class="py-0 body-2 account-message-text"
                                    >
                                        {{ message.text }}
                                    </v-flex>
                                </v-layout>
                                <v-layout
                                    row
                                    justify-end
                                    style="font-size: 11px"
                                >
                                    <v-spacer></v-spacer>
                                    <div
                                        class="text-xs-right px-2 account-message-status"
                                        style=""
                                    >
                                        {{ message.smsStatus }}
                                    </div>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-timeline-item>
                </div>
            </v-timeline>
        </v-card>
        <v-divider></v-divider>
        <v-layout row class="mx-1 mt-1">
            <v-textarea
                class="mr-1"
                hide-details
                label="Type a Message..."
                v-model="newMessage"
                ref="newMessage"
                rows="1"
            ></v-textarea>
            <v-btn
                @click="sendMessage"
                :disabled="disableSend()"
                :loading="sending"
                color="success"
            >
                <v-icon>mdi-send</v-icon>
            </v-btn>
        </v-layout>
        <v-layout row class="mb-2 pl-2" justify-start>
            <v-select
                style="max-width: 300px"
                hide-details
                class="mx-2"
                :items="fromPhones"
                label="From Number"
                ref="fromPhone"
                v-model="fromPhone"
                :rules="[rules.required]"
            >
                <template slot="selection" slot-scope="data">
                    {{
                        formatPhoneNumber(data.item.number) +
                            " - " +
                            data.item.description
                    }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title
                            v-html="
                                `${formatPhoneNumber(data.item.number)} - ${
                                    data.item.description
                                }`
                            "
                        >
                        </v-list-tile-title>
                    </v-list-tile-content>
                </template>
            </v-select>
            <v-select
                style="max-width: 300px"
                hide-details
                class="mx-2"
                :items="accountPhones"
                label="To Number"
                ref="toPhone"
                v-model="toPhone"
            ></v-select>
        </v-layout>
    </div>
</template>
<script>
import {
    formatCurrency,
    except,
    toTitleCase,
    toISOLocal,
    formatPhoneNumber,
} from "../../utils/helpers.js";
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import debounce from "lodash/debounce";

export default {
    props: {
        accountID: String,
        name: String,
        goToMessageSection: Boolean,
        firebaseRef: Object,
        fromNumber: String,
    },
    data() {
        return {
            messages: [],
            all: [],

            sending: false,

            newMessage: "",

            lastMessageNotifications: [],

            lastNotificationAt: "",

            messageTooltip: [],

            processing: false,
            loading: true,

            toPhone: "",
            fromPhone: "",
            accountPhones: [],
            fromPhones: [],
            messagesCount: 0,

            scrollTimeout: null,
            keypressTimeout: null,

            fromDate: toISOLocal(
                new Date(moment().subtract(1, "months")),
            ).substr(0, 10),
            datePickerMenu: false,

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    watch: {
        // accountID(newValue, oldValue) {
        //     if (newValue) {
        //         this.loadMessages();
        //     }
        // },
    },
    async created() {
        //await this.loadMessagesCount();
        await this.loadMessages();
        await this.loadAccountPhones();
        await this.loadFromPhones();

        this.setup();

        this.firebaseSetup();
    },
    mounted() {
        window.addEventListener("keypress", this.handleEnterKey);

        // if (this.$refs && this.$refs.accountMessages) {
        //     this.$refs.accountMessages.$el.addEventListener(
        //         "scroll",
        //         this.onScroll,
        //     );
        // }

        if (this.$refs && this.$refs.newMessage) {
            this.$refs.newMessage.focus();
        }

        document.addEventListener("DOMContentLoaded", function() {
            if (!Notification) {
                alert(
                    "Desktop notifications not available in your browser. Try google chrome.",
                );
                return;
            }

            if (Notification.permission !== "granted")
                Notification.requestPermission();
        });
    },
    beforeDestroy() {
        window.removeEventListener("keypress", this.handleEnterKey);

        // this.$refs.accountMessages.$el.removeEventListener(
        //     "scroll",
        //     this.onScroll,
        // );
    },
    computed: {},
    methods: {
        onScroll() {
            // We use a timeout to be sure to get the scroll event only once
            if (this.scrollTimeout) {
                window.clearTimeout(this.scrollTimeout);
            }

            this.scrollTimeout = window.setTimeout(() => {
                console.log("scroll");
                this.loadMoreMessages();
            }, 100);
        },
        handleEnterKey(event) {
            if (event.which == 13 && !event.shiftKey && this.newMessage) {
                event.preventDefault();

                if (this.keypressTimeout) {
                    window.clearTimeout(this.keypressTimeout);
                }

                this.keypressTimeout = window.setTimeout(() => {
                    this.sendMessage();
                }, 100);
            }
        },
        async loadAccountPhones() {
            const accountPhones = await this.$http.get(
                "api/broadcast/getAccountPhones?accountID=" + this.accountID,
            );

            this.accountPhones = accountPhones.map(
                (p) => p.phoneNum + " (" + p.phoneType + ")",
            );

            if (this.accountPhones.length == 1) {
                this.toPhone = this.accountPhones[0];
            }
        },
        async loadFromPhones() {
            // if (this.fromNumber) {
            //     this.fromPhones = [this.fromNumber];
            //     this.fromPhone = this.fromNumber;

            //     return;
            // }

            this.fromPhones = await this.$http.get(
                "api/broadcast/getFromPhoneNumbers?" +
                    (this.fromNumber ? "&fromNumber=" + this.fromNumber : ""),
            );

            if (this.fromPhones.length == 1) {
                this.fromPhone = this.fromPhones[0];
            }
        },
        setup() {
            const incomingMessages = this.messages.filter(
                (m) => m.direction == "INC",
            );
            const lastIncomingMessage =
                incomingMessages[incomingMessages.length - 1];

            if (lastIncomingMessage) {
                this.lastMessageNotifications.push(lastIncomingMessage.id);
            }

            const lastMessage = this.messages[this.messages.length - 1];

            if (lastMessage) {
                const number =
                    lastMessage.direction == "OUT"
                        ? lastMessage.from
                        : lastMessage.to;

                this.fromPhone = this.fromPhones.find(
                    (p) => p.number == number,
                );
            }
        },
        selectToPhone(phone) {
            this.toPhone = phone;
        },
        async markAsCompleted(message, all = false) {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/smsPendingMessages/markAsCompleted",
                    {
                        messageID: message.id,
                        accountID: this.accountID,
                        markAll: all,
                    },
                );

                this.processing = false;

                this.closeTooltip(message);
            } catch (e) {
                this.processing = false;
            }
        },
        async markAsUnread(message) {
            this.processing = true;

            try {
                await this.$http.post("api/smsPendingMessages/markAsUnread", {
                    messageID: message.id,
                    accountID: this.accountID,
                });

                this.processing = false;

                this.closeTooltip(message);
            } catch (e) {
                this.processing = false;
            }
        },
        firebaseSetup() {
            this.firebaseRef.on(
                "value",
                (snapshot) => {
                    this.loadMessages();
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            if (this.$store.state.app.accountMessageListner != this.accountID) {
                this.firebaseRef.on(
                    "child_changed",
                    this.onChildChanged,
                    function(error) {
                        console.log("Error: " + error.code);
                    },
                );
            }

            this.$store.commit("app/setAccountMessageListner", this.accountID);
        },
        async loadMessagesCount() {
            if (!this.accountID) return;

            const response = await this.$http.get(
                "api/broadcast/GetAccountMessagesCount?accountID=" +
                    this.accountID +
                    (this.fromNumber ? "&fromNumber=" + this.fromNumber : ""),
            );
            this.messagesCount = response;
        },
        async loadMessages() {
            if (!this.accountID) return;

            //this.loading = true;

            const messages = await this.$http.get(
                "api/broadcast/getAccountMessages?accountID=" +
                    this.accountID +
                    (this.fromNumber ? "&fromNumber=" + this.fromNumber : "") +
                    (this.fromDate ? "&fromDate=" + this.fromDate : ""),
            );

            //this.all = messages;
            this.messagesCount = this.all.length;
            this.messages = messages;
            // this.messages = messages.slice(0, 10);
            // this.messages = this.messages.sort((a, b) => {
            //     if (Date.parse(a.dateTime) > Date.parse(b.dateTime)) return 1;
            //     if (Date.parse(a.dateTime) < Date.parse(b.dateTime)) return -1;
            //     return 0;
            // });

            this.loading = false;

            const last = this.messages[this.messages.length - 1];

            if (last) {
                const lastNumber =
                    last.direction == "OUT" ? last.to : last.from;

                const accountPhone = this.accountPhones.find((phone) => {
                    const parts = phone.split(" ");

                    return parts[0] == lastNumber;
                });

                if (!accountPhone) {
                    this.accountPhones.splice(0, 0, lastNumber);

                    this.toPhone = lastNumber;
                } else {
                    this.toPhone = accountPhone;
                }
            }
        },
        async loadMoreMessages() {
            const length = this.messages.length;

            if (this.messages.length >= this.messagesCount) return;

            // const messages = await this.$http.get(
            //     "api/broadcast/getAccountMessages?accountID=" +
            //         this.accountID +
            //         (this.fromNumber ? "&fromNumber=" + this.fromNumber : "") +
            //         "&skip=" +
            //         length +
            //         "&top=10",
            // );

            const messages = this.all
                .filter((m) => {
                    const alreadyInList = this.messages
                        .map((m) => m.id)
                        .some((i) => i == m.id);

                    return !alreadyInList;
                })
                .slice(0, 5);

            this.messages.unshift(...messages);
            this.messages = this.messages.sort((a, b) => {
                if (Date.parse(a.dateTime) > Date.parse(b.dateTime)) return 1;
                if (Date.parse(a.dateTime) < Date.parse(b.dateTime)) return -1;
                return 0;
            });

            this.loading = false;
        },
        onChildChanged(snapshot) {
            this.loadMessages();

            const lastUpdated = snapshot.val().LastUpdated;

            if (this.lastNotificationAt == lastUpdated) return;

            this.lastNotificationAt = lastUpdated;

            this.newMessageNotification();
        },
        fromDateChanged(value) {
            this.loadMessages();
        },
        openMarkCompletedTooltip(message) {
            if (!this.messageTooltip.includes(message.id)) {
                this.messageTooltip.push(message.id);
            }
        },
        closeTooltip(message) {
            const element = this.messageTooltip.find((m) => m == message.id);

            if (!element) return;

            const index = this.messageTooltip.indexOf(element);

            this.messageTooltip.splice(index, 1);
        },
        reply(message) {
            const accountPhone = this.accountPhones.find((phone) => {
                const parts = phone.split(" ");

                return parts[0] == message.from;
            });

            if (!accountPhone) {
                this.accountPhones.splice(0, 0, message.from);

                this.toPhone = message.from;
            } else {
                this.toPhone = accountPhone;
            }

            const utaPhone = this.fromPhones.find(
                (p) => p.number == message.to,
            );

            if (utaPhone) {
                this.fromPhone = utaPhone;
            }
        },
        async sendMessage() {
            if (!this.fromPhone) {
                this.$notify({
                    text: "Please select a 'FROM' number.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.toPhone) {
                this.$notify({
                    text: "Please select a 'TO' number.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const lastMessage = this.messages[this.messages.length - 1];

            this.sending = true;

            try {
                await this.$http.post("api/broadcast/sendMessageToAccount", {
                    from: this.fromPhone.number,
                    to: this.getToPhone(this.toPhone),
                    accountId: this.accountID,
                    text: this.newMessage,
                    username: this.$store.state.authentication.user,
                });

                this.newMessage = "";

                this.sending = false;

                //this.loadMessages();
            } catch (e) {
                this.sending = false;
            }
        },
        getToPhone(value) {
            const parts = value.split(" ");

            return parts[0];
        },
        disableSend() {
            return !this.newMessage
                .replace(/\r\n/g, "<br />")
                .replace(/[\r\n]/g, "");
        },
        async newMessageNotification() {
            if (Notification.permission !== "granted")
                Notification.requestPermission();
            else {
                const messages = await this.$http.get(
                    "api/broadcast/getAccountMessages?accountID=" +
                        this.accountID +
                        (this.fromDate ? "&fromDate=" + this.fromDate : ""),
                );
                const incomingMessages = messages.filter(
                    (m) => m.direction == "INC",
                );
                const lastMessage =
                    incomingMessages[incomingMessages.length - 1];

                if (!this.lastMessageNotifications.includes(lastMessage.id)) {
                    this.lastMessageNotifications.push(lastMessage.id);

                    new Notification("New Message from " + this.name, {
                        icon:
                            "https://utaw.blob.core.windows.net/images/logo+uta11.png",
                        body: lastMessage.text,
                    });
                }
            }
        },
        scrollDown() {
            const lastMessage = this.messages[this.messages.length - 1];

            if (lastMessage) {
                const element = document.getElementById(lastMessage.id);
                element.scrollTop = element.scrollHeight;
            }
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatDate(date) {
            if (!date) return;

            return moment(date).format("L");
        },
        toEstTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatPhoneNumber(number) {
            if (!number) return "";

            const value = number.length == 11 ? number.substring(1) : number;

            return formatPhoneNumber(value);
        },
    },
};
</script>
<style>
.sms-date-filter-row {
    min-height: 48px;
    flex: 0 0 auto;
}

.sms-date-field {
    max-width: 220px;
    flex: 0 0 auto;
}

.sms-date-field .v-input__slot {
    margin-bottom: 0;
}

.petition-timeline .v-timeline-item {
    padding-bottom: 15px !important;
}
.account-messages-scroll-down {
    overflow-y: auto;
    height: 400px;
    display: flex;
    flex-direction: column-reverse;
}
.account-message-text {
    white-space: pre-line;
    margin-top: -20px;
}
.account-message-status {
    width: fit-content;
    background-color: purple;
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
}

.account-message-status-pending {
    background-color: rgb(253, 180, 0);
    cursor: pointer;
}

.account-message-status-completed {
    background-color: rgb(92, 184, 96);
}

.mark-as-completed-tooltip .v-tooltip__content {
    pointer-events: auto !important;
    background: #eef2f5 !important;
    border: 1px solid #ced9e2 !important;
}

.mark-message-button {
    font-weight: 600 !important;
    font-size: 14px !important;
    color: #fff;
}

.mark-message-button:hover {
    background-image: none !important;
    background-color: rgb(92, 184, 96) !important;
    color: #fff !important;
}
.sms-phone-number-list .v-navigation-drawer .v-list {
    background: unset !important;
}

.selected-phone {
    background-color: rgb(92, 184, 96) !important;
    color: #fff !important;
}

.sms-phone-number-list-drawer {
    border: 2px rgb(92, 184, 96) solid;
    border-radius: 3px;
}
</style>
